import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import LayoutPage from "../Layout";
import axios from "axios";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import styled from "styled-components";

function AddArticles() {
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [image, setImage] = useState();
  const [initialValues, setInitialValues] = useState({
    topic: "",
    heading: "",
    content: "",
    description: "",
    pdfFile: null,
  });
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    topic: Yup.string()
      .max(10, "Topic must be at most 10 character")
      .trim()
      .required("Topic is required"),
    heading: Yup.string()
      .max(500, "Heading must be at most 500 characters")
      .trim()
      .required("Heading is required"),
    description: Yup.string()
      .max(2000, "Description must be at most 2,000 characters")
      .trim()
      .required("Description is required"),
    pdfFile: Yup.mixed()
      .required("PDF is required")
      .test("fileFormat", "Only PDF files are allowed", (value) => {
        if (value) {
          const supportedFormats = ["pdf"];
          return supportedFormats.includes(value.name.split(".").pop());
        }
        return true;
      }),
  });

  const handleNewsImage = (e) => {
    const file = e.target.files[0];
    setImage(file);
    formik.setFieldValue("newsImage", file);
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: async (values) => {
      // console.log("Values=> ", values);
      let formData = new FormData();
      formData.append("topic", values.topic);
      formData.append("heading", values.heading);
      formData.append("description", values.description);
      formData.append("pdfFile", values.pdfFile);
      setDisabledSubmit(true);
      try {
        let res = await axios.post(`admin-website/create-research-articles`, formData);
        // console.log(res);
        navigate("/research-articles", {
          state: { message: res.data.data.message },
        });
        toast(res.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "success",
        });
      } catch (errors) {
        if (errors.response.data.error) {
          toast(errors.response.data.error.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          });
        } else {
          toast(errors.response.data.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          });
        }

        setDisabledSubmit(false);
      }
    },
  });

  return (
    <>
      <Helmet>
        <title>Add Articles</title>
      </Helmet>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className=" shadow-primary border-radius-lg pt-4 pb-3"
                >
                  <div className="d-flex ps-3 align-item-center">
                    <i
                      style={{ color: "#fff", cursor: "pointer" }}
                      className="fa fa-arrow-left fs-4"
                      onClick={() => {
                        navigate(-1);
                      }}
                    ></i>
                    <h6 className="text-white text-capitalize ps-4 ">
                      ADD RESEARCH ARTICLE
                    </h6>
                  </div>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Topic</label>

                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="topic"
                        name="topic"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Topic"
                        value={formik.values.topic || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {formik.errors.topic ? (
                      <div className="text-danger">{formik.errors.topic}</div>
                    ) : null}

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Heading</label>

                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="heading"
                        name="heading"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Heading"
                        value={formik.values.heading || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {formik.errors.heading ? (
                      <div className="text-danger">{formik.errors.heading}</div>
                    ) : null}

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Description</label>
                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="description"
                        name="description"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Description "
                        value={formik.values.description || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {formik.errors.description ? (
                      <div className="text-danger">
                        {formik.errors.description}
                      </div>
                    ) : null}

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Research Pdf</label>
                      <input
                        style={{
                          width: "100%",
                          padding: "10px",
                          fontSize: "16px",
                          borderRadius: "5px",
                          outline: "none",
                          border: "1px solid #ccc",
                        }}
                        // onChange={handleFolderSelect}
                        // webkitdirectory="true"
                        // directory="true"
                        // multiple
                        type="file"
                        name="pdfFile"
                        // accept=".pdf"
                        onChange={(event) => {
                          formik.setFieldValue(
                            "pdfFile",
                            event.target.files[0]
                          );
                        }}
                        // onChange={handleNewsImage}
                      />
                    </div>
                    {formik.errors.pdfFile ? (
                      <div className="text-danger">{formik.errors.pdfFile}</div>
                    ) : null}

                    <div className="text-center d-flex justify-content-center gap-4">
                      <button
                        type="submit"
                        className="btn btn-lg  btn-lg w-20 mt-4 mb-0"
                        disabled={disabledSubmit}
                        style={{
                          backgroundColor: "#46456e",
                          color: "#fff",
                        }}
                      >
                        {disabledSubmit ? (
                          <div>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="sr-only"></span> Submitting
                          </div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                      <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="btn btn-lg  btn-lg w-20 mt-4 mb-0 "
                        disabled={disabledSubmit}
                        style={{
                          backgroundColor: "#46456e",
                          color: "#fff",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default AddArticles;
